module.exports = __webpack_public_path__ + "img/6.1a75d7a7.jpg";